import React, { Component } from 'react';
import "../../../css/general-style.css";
import '../../../css/table-responsive.css';
import "../../../css/dashboard.css";
import styles from '../../../css/AddNewProduct.module.css';
import LoadingWindow from '../../../components/LoadingWindow';
import Select from 'react-select';
import Swal from 'sweetalert2'
import { RiArrowGoBackFill } from 'react-icons/ri';
import { MdPhotoCamera } from 'react-icons/md';
import { getValueCookie } from '../../../services/cookieService';
import { getInformationWithData } from '../../../services/CABE';

// Menu
import { Menu } from "../../../components/Menu/Menu";

export default class AddNewProduct extends Component {

    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        productName: '',
        itemCode: '',
        productLine: '',
        vendorNo: '',   
        upc: '',
        upc2: '',
        caseUpc: '',
        um: '',
        weight: '',
        length: '',
        height: '',
        width: '',
        initialStock: '',
        costPrice: '',
        ProductLineList: [],
        VendorList: [],
        categories: [],
        subcategories: [],
        validForm: false
    }
    
    componentDidMount(){
        this.getProductLines();
        this.getVendor();
    }

    handleSelectChange = async (selectedOption, fieldName) => {
        // react-select passes the option object {value, label}, not a DOM event
        this.setState({ [fieldName]: selectedOption ? selectedOption.value : '' });
    }

    async getProductLines() {
        const response = await getInformationWithData('/Items/get-exception-items');
        this.setState({ ProductLineList: response.data.data})
    }

    async getVendor() {
        const data = {
            idCompany: getValueCookie('CompanyId')
        }
        const response = await getInformationWithData('/vendors/get/vendorsInformation', data);
        this.setState({ VendorList: response.data})
    }
    
    async getCategories(){
        const response = await getInformationWithData('/v2/items/categories-with-subcategories');
        const { categories, subcategories } = response.data
        this.setState({ categories, subcategories })
    }

    async createProduct() {
        this.checkForm();
    }

    checkForm = async () => {
        
        // Validate the upc values has no letters
        const { itemCode, upc, caseUpc } = this.state;
        
        const upcVal = this.hasLetters(upc);
        const caseUpcVal = this.hasLetters(caseUpc);
        
        if(upcVal || caseUpcVal){
            Swal.fire({
                title: 'Invalid Upc values',
                text: "Some upc has invalid characters.",
                icon: 'warning',
                confirmButtonColor: '#3aa0ff',
                confirmButtonText: 'OK',
            })
            return
        }
        // Validate itemCode and upc are unique
        const responseCheck = await getInformationWithData('/v2/items/exists', {data: {upc, itemCode}})
        const { upc_exists, item_code_exists } = responseCheck.data;
        if(upc_exists > 0 || item_code_exists > 0){
            Swal.fire({
                title: 'Item Code or UPC Already Exists',
                text: "Both the Item Code and the UPC must be unique.",
                icon: 'warning',
                confirmButtonColor: '#3aa0ff',
                confirmButtonText: 'OK',
            })
            return
        }

    }
    
    
    hasLetters(str) {
        return /[a-zA-Z]/.test(str);
    }
    
    handleChange = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value
        })
    }

    render() {
        const { ProductLineList, VendorList } = this.state;

        const selectStyle = {
            control: (base, state) => ({
                ...base,
                borderRadius: '10px',
                border: state.isFocused ? '1.5px solid #2563EB' : '1px solid #E2E8F0',
                boxShadow: state.isFocused ? '0 0 0 3px rgba(37,99,235,0.1)' : 'none',
                fontSize: '1rem',
                minHeight: '44px',
            }),
        };

        return (
            <div className="dash-page container-fluid pb-5">
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />

                <div className="container-fluid" style={{ paddingTop: '1.5rem' }}>

                    {/* ── Hero ── */}
                    <div style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #2563EB 100%)',
                        borderRadius: '16px',
                        padding: '2rem 2.5rem',
                        marginBottom: '2rem',
                        marginTop: '2rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                        gap: '1rem',
                    }}>
                        <div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
                                <MdPhotoCamera style={{ fontSize: '1.75rem', opacity: 0.9 }} />
                                <h2 style={{ fontFamily: "'Archivo', sans-serif", fontWeight: 800, fontSize: '1.75rem', margin: 0 }}>
                                    Add New Product
                                </h2>
                            </div>
                            <p style={{ margin: 0, opacity: 0.8, fontSize: '0.9375rem' }}>
                                Create a new item in the product catalogue · {getValueCookie('Company')}
                            </p>
                        </div>
                        <a
                            href="/inventory/products"
                            style={{
                                background: 'rgba(255,255,255,0.15)',
                                border: '1px solid rgba(255,255,255,0.3)',
                                borderRadius: '10px',
                                color: 'white',
                                textDecoration: 'none',
                                padding: '0.6rem 1.25rem',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.4rem',
                            }}
                        >
                            <RiArrowGoBackFill /> Back to Products
                        </a>
                    </div>

                    {/* ── Form ── */}
                    <div className="row g-4">

                        {/* Left: Image upload */}
                        <div className="col-lg-3">
                            <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                                <div className={styles.cardHeaderCustom}>
                                    <h3 className={styles.cardTitle}>Product Image</h3>
                                </div>
                                <div className={styles.cardBodyCustom}>
                                    <div className={styles.imageContainer}>
                                        <img src="" alt="New Product" id="createProductImg" style={{ display: 'none' }} />
                                        <div className={styles.uploadPlaceholder} id="createPlaceholder">
                                            <div className={styles.uploadIcon}><MdPhotoCamera /></div>
                                            <p style={{ margin: 0, fontWeight: 500 }}>Click to upload</p>
                                            <p style={{ margin: 0, fontSize: '0.875rem' }}>PNG, JPG up to 10MB</p>
                                        </div>
                                        <button className={styles.changeBtn} type="button">Upload Image</button>
                                    </div>
                                    <input type="file" id="createFileInput" style={{ display: 'none' }} accept="image/*" />
                                    <p className={styles.formHelpText} style={{ marginTop: '1rem' }}>
                                        Recommended: Square image, min 800×800px
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* Right: Form fields */}
                        <div className="col-lg-9">
                            <form onSubmit={e => { e.preventDefault(); this.createProduct(); }}>

                                <div className={`${styles.cardModern} ${styles.fadeIn}`}>
                                    <div className={styles.cardHeaderCustom} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                        <h3 className={styles.cardTitle}>Product Details</h3>

                                        <p style={{ margin: 0, fontSize: '0.9rem', color: '#64748B' }}>
                                            <span className={styles.requiredIndicator} style={{fontWeight: 'bold'}}>*</span> Required Fields
                                        </p>
                                    </div>
                                    <div className={styles.cardBodyCustom}>

                                        {/* ── Identity ── */}
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Product Name <span className={styles.requiredIndicator}>*</span></label>
                                                    <input type="text" name="productName" className={styles.formInput} placeholder="Full product name" required onChange={this.handleChange} />
                                                    <p className={styles.formHelpText}>Clear, descriptive name</p>
                                                </div>
                                            </div>
                                            <div className={`col-md-6 ${styles.formCenter}`}>
                                                <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer', fontSize: '0.9375rem', fontWeight: 500, color: '#334155' }}>
                                                    <input type="checkbox" name="preSale" onChange={this.handleChange} style={{ width: '16px', height: '16px', accentColor: '#2563EB' }} />
                                                    Pre-Sale Product
                                                </label>
                                            </div>
                                        </div>

                                        <hr className={styles.sectionDivider} />
                                        <h4 className={styles.sectionTitle}>Classification</h4>

                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Item Code <span className={styles.requiredIndicator}>*</span></label>
                                                    <input type="text" name="itemCode" className={styles.formInput} placeholder="e.g. FOOD-001" required onChange={this.handleChange} />
                                                    <p className={styles.formHelpText}>Must include the product line prefix</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Product Line <span className={styles.requiredIndicator}>*</span></label>
                                                    <Select
                                                        isSearchable
                                                        styles={selectStyle}
                                                        id="ProductLineSelector"
                                                        placeholder="Select product line…"
                                                        onChange={opt => this.handleSelectChange(opt, 'productLine')}
                                                        options={ProductLineList ? ProductLineList.map(pl => ({ value: pl.ProductLine, label: pl.ProductLineDesc })) : []}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Primary Vendor <span className={styles.requiredIndicator}>*</span></label>
                                                    <Select
                                                        isSearchable
                                                        styles={selectStyle}
                                                        id="VendorSelector"
                                                        placeholder="Select vendor…"
                                                        onChange={opt => this.handleSelectChange(opt, 'vendorNo')}
                                                        options={VendorList ? VendorList.map(v => ({ value: v.customerNo, label: v.name })) : []}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <hr className={styles.sectionDivider} />
                                        <h4 className={styles.sectionTitle}>Barcodes</h4>

                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>UPC <span className={styles.requiredIndicator}>*</span></label>
                                                    <input type="text" name="upc" className={styles.formInput} placeholder="012345678901" required onChange={this.handleChange} />
                                                    <p className={styles.formHelpText}>Primary barcode — numbers only</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>UPC 2 <span style={{ color: '#94A3B8', fontWeight: 400, textTransform: 'none', fontSize: '0.75rem' }}>(optional)</span></label>
                                                    <input type="text" name="upc2" className={styles.formInput} placeholder="098765432109" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Case UPC <span className={styles.requiredIndicator}>*</span></label>
                                                    <input type="text" name="caseUpc" className={styles.formInput} placeholder="112233445566" required onChange={this.handleChange} />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Unit of Measure</label>
                                                    <input type="text" name="um" className={styles.formInput} placeholder="e.g. EA, CS, LB" onChange={this.handleChange} />
                                                </div>
                                            </div>
                                        </div>

                                        <hr className={styles.sectionDivider} />
                                        <h4 className={styles.sectionTitle}>Physical Dimensions</h4>

                                        <div className="row g-3">
                                            {[
                                                { name: 'weight', label: 'Weight', unit: 'lbs', required: true },
                                                { name: 'length', label: 'Length', unit: 'in',  required: true },
                                                { name: 'height', label: 'Height', unit: 'in',  required: true },
                                                { name: 'width',  label: 'Width',  unit: 'in',  required: true },
                                            ].map(f => (
                                                <div key={f.name} className="col-md-6">
                                                    <div className={styles.formGroup}>
                                                        <label className={styles.formLabel}>
                                                            {f.label} {f.required && <span className={styles.requiredIndicator}>*</span>}
                                                        </label>
                                                        <div className={styles.formInputGroup}>
                                                            <input
                                                                type="number"
                                                                name={f.name}
                                                                className={styles.formInput}
                                                                placeholder="0.0"
                                                                step="0.1"
                                                                min="0"
                                                                required={f.required}
                                                                onChange={this.handleChange}
                                                                onWheel={e => e.target.blur()}
                                                            />
                                                            <span className={styles.inputUnit}>{f.unit}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        <hr className={styles.sectionDivider} />
                                        <h4 className={styles.sectionTitle}>Inventory &amp; Pricing</h4>

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Initial Stock</label>
                                                    <input type="number" name="initialStock" className={styles.formInput} placeholder="0" min="0" onChange={this.handleChange} />
                                                    <p className={styles.formHelpText}>Starting quantity on hand</p>
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className={styles.formGroup}>
                                                    <label className={styles.formLabel}>Cost Price</label>
                                                    <div className={styles.formInputGroup}>
                                                        <span className={styles.inputUnit} style={{ marginLeft: 0, marginRight: '0.05rem' }}>$</span>
                                                        <input type="number" name="costPrice" className={styles.formInput} placeholder="0.00" step="0.01" min="0" onChange={this.handleChange} onWheel={e => e.target.blur()} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                {/* ── Sticky action bar ── */}
                                <div className={styles.bottomActionBar}>
                                    <div></div>
                                    <div className={styles.btnGroup}>
                                        <a
                                            href="/inventory/products"
                                            className={`${styles.actionBtn} ${styles.btnSecondaryCustom}`}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            Cancel
                                        </a>
                                        <button
                                            type="submit"
                                            className={`${styles.actionBtn} ${styles.btnSaveCustom}`}
                                        >
                                            Create Product
                                        </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}
